import './core/assets/styles/custom.scss';
import './app.scss';
import Home from './core/components/Home';

const App = () => (
    <Home />
)

export default App;
